export default (context) => {
    return {
  
      config: {
        pageSize: 40,
        list: false,
        remapRow: (form) => {
          return form
        }
      },
  
      actions: {
        create: {
          reloadGrid: true
        },
        edit: {
          reloadGrid: true
        },
        delete: true,
        print: false,
        export: false,
        search: true
      },
  
      filter: {
        fields: [
          {
            name: "type",
            value: { value: "none", label: "[Seleccionar]" },
            type: "select",
            label: "Tipo",
            opts: {
              style: 'float-label',
              path: "/admOtlt/types",
              remap: (r) => {
                if (r.data.Results) r.data.Results = r.data.Results.map(e => e = { ID: e, name: e })
                return r
              },
              isClearable: false
            },
            onChange: (ctx) => {
              if (context.state.formFilter.type && (context.state.formFilter.type.value === ctx.state.type)) return
              process.nextTick(() => { context.resetDataTable() })
            }
          },
        ]
      },

      form: {
        remapOne: (r) => {
          if (r.status >= 0) {
            r.data.type = {value: r.data.type, label: r.data.type }
          }
          return r
        },
        setValuesBeforePost: (v) => {
          return v
        },
        fields: [
          {
            col: 12,
            name: "type",
            value: null,
            type: "select",
            label: "Tipo",
            rules: 'required',
            opts: {
              style: 'float-label',
              path: "/admOtlt/types",
              remap: (r) => {
                if (r.data.Results) r.data.Results = r.data.Results.map(e => e = { ID: e, name: e })
                return r
              }
            }
          },
          {
            col: 6,
            name: "value",
            value: "",
            type: "text",
            label: "Valor",
            rules: 'required',
            opts: {
              style: 'float-label'
            }
          },
          {
            col: 6,
            name: "label",
            value: "",
            type: "text",
            label: "Etiqueta",
            rules: 'required',
            opts: {
              style: 'float-label'
            }
          },
          {
            col: 6,
            name: "createdDate",
            value: null,
            type: "datetime",
            label: `Fecha creación`,
            opts: {
              style: 'float-label'
            },
            disabled: true,
            renderIf: (ctx) => { return context.state.idItemSelected }
          },
          {
            col: 6,
            name: "createdByName",
            value: null,
            type: "text",
            label: `Creado por`,
            opts: {
              style: 'float-label'
            },
            disabled: true,
            renderIf: (ctx) => { return context.state.idItemSelected }
          },
          {
            col: 6,
            name: "updatedDate",
            value: null,
            type: "datetime",
            label: "Fecha modificación",
            opts: {
              style: 'float-label'
            },
            disabled: true,
            renderIf: (ctx) => { return context.state.idItemSelected }
          },
          {
            col: 6,
            name: "updatedByName",
            value: null,
            type: "text",
            label: `Modficado por`,
            opts: {
              style: 'float-label'
            },
            disabled: true,
            renderIf: (ctx) => { return context.state.idItemSelected }
          },
          {
            col: 12,
            name: "inactive",
            value: false,
            type: "switch",
            label: "main.inactive"
          }
        ]
      },
  
      columns: [
        {
          Header: "ID",
          accessor: "ID",
          width: 50
        },
        {
          Header: "Valor",
          accessor: "value"
        },
        {
          Header: "Etiqueta",
          accessor: "label"
        },
        {
          Header: "Estado",
          accessor: "inactive",
          type: 'chip',
          chips: {
            false: {text:'',color:'lightgreen'},
            true: {text:'',color:'orange'}
          }
        },
        {
          Header: "Fecha creación",
          accessor: "createdDate",
          isDate: true
        },
        {
          Header: "Fecha modificación",
          accessor: "updatedDate",
          isDate: true
        }
      ]
    }
  }